import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';
import MainContent from "@components/content";

export default function AdmInvoices() {
  let { id } = useParams();
  const [history, setHistory] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [page, setPage] = useState(0);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/documents`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }
    })
    .then(response  => {
      setDocuments(response.data);
    })
    .catch(error => {
      setHistory([]);
    });

    axios.get(`${import.meta.env.VITE_API_ADM_URL}/users`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }
    })
    .then(response  => {
      setUsers(response.data);
    })
    .catch(error => {
      setUsers([]);
    });
  }, []);

  const downloadFile = async (type: number, documentId: string) => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_ADM_URL}/user/${id}/documents/${type === 0 ? 'getInvoice' : 'getClosing'}/${documentId}`, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
          },
          responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `${type === 0 ? 'invoice' : 'act'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <MainContent>
      <h1 style={{ margin: 0, fontSize: 22 }}>Выставленные счета</h1>
      <div className={css.table}>
        <div className={css.tableHeader}>
          <a>Имя документа</a>
          <a>Дата добавления</a>
          <a>Партнёр</a>
        </div>

        <div className={css.tableBody}>
          {documents
          .filter((item: any) => page === 0 || (page === 1 && item.type === 0) || (page === 2 && item.type === 1))
          .map((item: any) => (
            <div className={css.tableDiv} key={item.id}>
              <a>{item.type == 0 && (item.status == 0 ? <i className={`${css.wait} fi fi-rr-clock`}></i> : <i className={`${css.payed} fi fi-rr-check-circle`}></i>)} {item.type === 0 ? `Счёт от ${new Date(item.createdAt).toLocaleDateString('ru-RU')}` : `Акт от ${new Date(item.createdAt).toLocaleDateString('ru-RU')}`}</a>
              <a>{new Date(item.createdAt).toLocaleDateString('ru-RU')} в {new Date(item.createdAt).toLocaleTimeString('ru-RU')}</a>
              <a href={`/admin/user/${item.userId}`} className={css.download}>{users.find((user: any) => user.id === item.userId)?.firstName} {users.find((user: any) => user.id === item.userId)?.lastName} <a onClick={() => downloadFile(item.type, item.id)}>Скачать PDF</a></a>
            </div>
          ))}
        </div>
      </div>
    </MainContent>
  )
}